const SceneBase = require("./scene-base.js");

class SceneAudio extends SceneBase {
    static type() {
        return "sceneaudio";
    }
}

module.exports = SceneAudio;